<template>
	<footer class="footer" :class="{show: show}">
		© 2020
	</footer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	data() {
		return {
			show: false
		}	
	},	
	methods: {
		check: function() {
			if(this.scroll) {
				// Bottom of page
				if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight) {
					this.show = true;				
				} else {
					this.show = false;
				}
			}
		}
	},
	computed: mapGetters(["scroll"]),
	watch: {
		// Right after "Wipe" transition
		scroll: function() {
			this.check();
		}
	},

	created() {		
		window.addEventListener('scroll', this.check);
		window.addEventListener('resize', this.check);
	},

	mounted() {
		this.check();
	},

	destroyed() {
		window.removeEventListener('scroll',this.check);
		window.removeEventListener('resize',this.check);
	}
}
</script>

<style scoped lang="scss">
@import "../styles/variables.scss";
@import "../styles/mixins.scss";

.footer {
	position: fixed;
	color: map-get($colors, 'prime-light');
	width: 100%;
	left: 0;
	bottom: 30px;
	z-index: 3;
	text-align: left;
	padding-left: 8.33vw;
	font-size: 11px;
	font-weight: 200;
	opacity: 0;
	transition: opacity .3s cubic-bezier(.19,1,.22,1);

	&.show {
		opacity: 1;
	}
}

@include tablet {

}
</style>